/* eslint-disable object-shorthand */
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './auth/auth.reducer';
import modalReducer from './modals/modalReducer';
import geoReducer from './geo/geo.reducer';
import complaintReducer from './complaint/complaint.reducer';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['cart']
};

const rootReducer = combineReducers({
  authReducer: authReducer,
  modals: modalReducer,
  geoReducer: geoReducer,
  complaintReducer: complaintReducer
});
export default persistReducer(persistConfig, rootReducer);
